import { render, staticRenderFns } from "./Revisar.vue?vue&type=template&id=f740182e"
import script from "./Revisar.vue?vue&type=script&lang=js"
export * from "./Revisar.vue?vue&type=script&lang=js"
import style0 from "./Revisar.vue?vue&type=style&index=0&id=f740182e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports